module.exports = __webpack_public_path__ + "static/shield@2x-06e11168ce3b8a93f33ca07669e16fa6.png";